/**
 * A board seen from elsewhere (Marek, 6 Oct 2026: "games are not showing on the big screen in real
 * time — only a progress status"). While the mirror is on, the phone hands out its board's view
 * state a few times a second as a `MirrorFrame`; any screen with the same module draws it with the
 * board's own `View` (thirty/mirror.tsx). The phone sends nothing more until something carries the
 * frames to the room; `taskProgress` and `taskFrame` go on as before either way.
 */
import type { Era } from '../../art.js';

/** At most one frame this often: about five a second. */
export const MIRROR_MS = 200;

/** One look at a board in play: small, and the same on every screen. */
export interface MirrorFrame {
  /** The game (show-core `ThirtyId`). */
  g: string;
  /** The era it is drawn in. */
  e: Era;
  /** The round, 0–2. */
  r: number;
  /** Between rounds (the ROUND 2 card is showing). */
  b: 0 | 1;
  /** The board's view state. */
  v: unknown;
}

/** A gate that lets a call through at most once every `ms`. */
export function throttle<A extends unknown[]>(ms: number, send: (...args: A) => void): (...args: A) => void {
  let last = -Infinity;
  return (...args: A) => {
    const now = performance.now();
    if (now - last < ms) return;
    last = now;
    send(...args);
  };
}
